import { CONFIG } from 'config/config';
import { UiWrapper } from '@coinscrap/webapp-core';


UiWrapper.defineComponent('button', {
	styles: {
		default: {
			minWidth: 150,
			boxSizing: 'border-box',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			alignContent: 'center',
			cursor: 'pointer',
			transition: '0.6s all',
			outline: 'none',
			border: `1px solid ${CONFIG.colors.primary}`,
			borderRadius: '3px',
			padding: '4px 12px',
			backgroundColor: CONFIG.colors.primary,
			textComponent: {
				color: CONFIG.colors.white,
				fontSize: CONFIG.fontSizes.md,
				fontFamily: CONFIG.fonts.semiBold,
				textAlign: 'center',
				display: 'flex',
				alignItems: 'center',
			},
			disabledMode: {
				opacity: 0.5,
			},
		},

		bigTextSt: {
			textComponent: {
				fontSize: CONFIG.fontSizes.lg,
			},
		},

		backButtonSt: {
			textComponent: {
				color: CONFIG.colors.primary,
			},
		},

		packagesDownloadPdfSt: {
			height: 50,
			flexGrow: 1,
		},

		sameHeightAsInputsSt: {
			padding: `calc(${CONFIG.inputs.padding.default} - 3px)`,
		},

		test: {
			padding: `calc(${CONFIG.inputs.padding.default} - 3px)`,
		},

		beneficiaryCircleOptionSt: {
			backgroundColor: CONFIG.colors.white,
			borderColor: CONFIG.colors.white,
			color: CONFIG.colors.white,
			borderRadius: 50,
			height: 25,
			margin: 0,
			width: 25,
		},

		...CONFIG.commonStyles.styles,
	},
});
